import React from 'react';
import Contact from '@components/contact-page';

const ContactPage: React.FC = () => {
  return <Contact />;
};

export default ContactPage;
